// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__54AS0","employee-header-item":"Header_employee-header-item__Wuemu"};